import React from 'react';
import Select from 'react-select';

class AutocompleteSelect extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.inputChange = this.inputChange.bind(this);

        this.state = {
            loading: false,
            search: ''
        };
    }

    inputChange(val) {
        this.setState({ search: val });
    }

    handleChange(val) {
        if (val !== null) {
            this.props.onChange(val);

            if (this.state.search !== '') {
                const option = this.refs.menu.select.focusedOptionRef;

                setTimeout(() => {
                    option.scrollIntoView();
                }, 100);
            }
        } else {
            this.props.onChange(null);
        }
    }

    render() {
        let customTheme = {
            colors: {
                primary: '#337ab7'
            }
        };

        let selectOptions = Object.keys(this.props.options).map((v) => {
            return { value: v, label: this.props.options[v] };
        });

        return (
            <div className="select-container">
                <div className="label">{this.props.label}</div>
                <div className="input-container">
                    {this.props.fixedOpen ? (
                        <Select
                            ref={'menu'}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    ...customTheme.colors
                                }
                            })}
                            className=""
                            isLoading={this.state.loading}
                            isClearable={true}
                            isSearchable={true}
                            menuIsOpen={true}
                            onInputChange={this.inputChange}
                            name="color"
                            options={selectOptions}
                            onChange={this.handleChange}
                            value={this.props.value}
                        />
                    ) : (
                        <Select
                            ref={'menu'}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    ...customTheme.colors
                                }
                            })}
                            className=""
                            isLoading={this.state.loading}
                            isClearable={true}
                            isSearchable={true}
                            onInputChange={this.inputChange}
                            name="color"
                            options={selectOptions}
                            onChange={this.handleChange}
                            value={this.props.value}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default AutocompleteSelect;
